import styled from 'styled-components';
import { textSizeStyles } from '../../../../../../../mixins/text/textSizeWeight';
import { getColorStylesLegacy } from '../../../../../../../mixins/text/textColorLegacy';
export const StyledMaskElement = styled.div.withConfig({
  componentId: "BaseInput__sc-15nxpj2-0"
})(["display:flex;flex-wrap:nowrap;position:absolute;pointer-events:none;user-select:none;", " ", ""], textSizeStyles('fs16'), getColorStylesLegacy('primary'));
export const StyledMaskElementHide = styled.span.withConfig({
  componentId: "BaseInput__sc-15nxpj2-1"
})(["visibility:hidden;white-space:break-spaces;overflow:hidden;word-break:break-all;"]);
export const StyledInput = styled.input.withConfig({
  componentId: "BaseInput__sc-15nxpj2-2"
})(["background-color:transparent;", " ", " width:100%;border:none;outline:none;box-sizing:border-box;&::placeholder{", "}"], textSizeStyles('fs16'), getColorStylesLegacy('primary'), getColorStylesLegacy('tertiary'));